"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.avatarVideoGenerationViewSchema = exports.avatarVideoTaskViewSchema = exports.avatarVideoStatusEnum = exports.digitalHumanAssetViewSchema = exports.listAssetQuerySchema = exports.registerAssetSchema = exports.presignUploadResponseSchema = exports.presignUploadSchema = exports.digitalHumanStateEnum = void 0;
const zod_1 = require("zod");
exports.digitalHumanStateEnum = zod_1.z.enum(['idle', 'speaking', 'listening', 'greeting']);
exports.presignUploadSchema = zod_1.z.object({
    csId: zod_1.z.string().uuid(),
    state: exports.digitalHumanStateEnum,
    mime: zod_1.z.enum(['video/mp4', 'video/webm']),
    size: zod_1.z.number().int().positive().max(50 * 1024 * 1024),
    filename: zod_1.z.string().min(1).max(256),
});
exports.presignUploadResponseSchema = zod_1.z.object({
    obsKey: zod_1.z.string(),
    uploadUrl: zod_1.z.string().url(),
    expiresIn: zod_1.z.number().int().positive(),
});
exports.registerAssetSchema = zod_1.z.object({
    csId: zod_1.z.string().uuid(),
    state: exports.digitalHumanStateEnum,
    obsKey: zod_1.z.string().min(1).max(512), // 视频 key (写入 video_key 列)
    posterKey: zod_1.z.string().max(512).nullable().optional(), // 首帧图 key (写入 poster_key 列)
    durationMs: zod_1.z.number().int().min(0),
});
exports.listAssetQuerySchema = zod_1.z.object({
    csId: zod_1.z.string().uuid(),
});
/** 出参 View (BE 投影 + 签名 URL) */
exports.digitalHumanAssetViewSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    siteId: zod_1.z.string().uuid(),
    merchantId: zod_1.z.string().uuid(),
    csId: zod_1.z.string().uuid(),
    state: exports.digitalHumanStateEnum,
    videoKey: zod_1.z.string(),
    videoUrl: zod_1.z.string().url(), // 签名 GET URL
    posterKey: zod_1.z.string().nullable(),
    posterUrl: zod_1.z.string().url().nullable(),
    durationMs: zod_1.z.number().int(),
    sort: zod_1.z.number().int(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
/**
 * 形象视频生成 — 目标行可用状态
 * （与 customer_services.avatar_video_status / system_avatars.video_status 一致）。
 */
exports.avatarVideoStatusEnum = zod_1.z.enum([
    'none',
    'pending',
    'generating',
    'ready',
    'failed',
]);
/** 单条生成任务明细（avatar_video_tasks 投影；进度/调试展示用） */
exports.avatarVideoTaskViewSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    // 任务状态机: pending/submitted/tts_running/synth_running/downloading/succeeded/failed/cancelled
    status: zod_1.z.string(),
    progress: zod_1.z.number().int(),
    externalTaskId: zod_1.z.string().nullable(),
    errorCode: zod_1.z.string().nullable(),
    errorMsg: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
/**
 * GET /admin/digital-human/avatars/:csId/generation 出参。
 * status / videoUrl / durationMs 取目标行（可用态）；task 为最近一条生成任务明细（可空）。
 */
exports.avatarVideoGenerationViewSchema = zod_1.z.object({
    targetType: zod_1.z.enum(['custom', 'system']),
    targetId: zod_1.z.string().uuid(),
    status: exports.avatarVideoStatusEnum,
    videoUrl: zod_1.z.string().nullable(),
    durationMs: zod_1.z.number().int().nullable(),
    task: exports.avatarVideoTaskViewSchema.nullable(),
});
//# sourceMappingURL=digital-human.js.map